import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMenu } from '../interfaces';
import * as fromMenuReducer from './org-admin-settings.reducer';

export const APPLICATION_CONFIGURATION = "Application Configuration";

export const getMenuState = createFeatureSelector<fromMenuReducer.IState>('adminSettings');

export const getMenus = createSelector(
  getMenuState,
  fromMenuReducer.getMenus
);

export const getGlobalMenus = createSelector(
  getMenuState,
  fromMenuReducer.getGlobalMenus
);

export const getAppsSelector = createSelector(
  getMenuState,
  (state: fromMenuReducer.IState) => state.applications
);

export const getSelected = createSelector(
  getMenuState,
  fromMenuReducer.getSelected
);

export const getAppConfigurationMenus = createSelector(
  getMenus,
  (menus) => menus.find(menu => menu.text === APPLICATION_CONFIGURATION).submenu
)

export const getSelectedAppMenuItem = createSelector(
  getSelected,
  getAppConfigurationMenus,
  (identity: string, menu: IMenu[]) => menu.find(item => item.identify === identity)
)

export const getSelectedApp = createSelector(
  getSelectedAppMenuItem,
  getAppsSelector,
  (menuItem: IMenu, applications:any) => menuItem && menuItem.text &&
    applications &&
    Object.values(applications).find((app:any) => app &&
    ((app.text === menuItem.text)||(app.text === menuItem.text.replace(/ /g, "")))) ||
    undefined
)

export const getSelectedMenu = createSelector(
  getSelected,
  getMenus,
  (selectedId, menus) => {
    const subMenu = menus.filter((menu) => {
      if (!selectedId) {
        selectedId = menu.identify;
      }

      return menu.identify === selectedId && menu.enable;
    });

    return subMenu.length ? subMenu[0].submenu : [];
  }
);

export const getAllMenus = createSelector(
  getMenus,
  (menus) => {
    return menus;
  }
);

export const getAllGlobalMenus = createSelector(
  getGlobalMenus,
  (globalMenus) => {
    return globalMenus;
  }
);

export const getAdminConfiguration = createSelector(
  getMenuState,
  fromMenuReducer.getConfiguration
);
